// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__6YRjf","templateDrawer":"Sidebar_templateDrawer__bANIv","sidebar":"Sidebar_sidebar__TCpoz"};